/**
 *
 */
export const internalsName = "gr-internals";

export const internalsField = Symbol(internalsName);
